<template>
  <div v-if="visible" class="popup-overlay" @click="close">
      <div class="popup" @click.stop>
      <button class="close-button" @click="close">✖</button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MainPopup',
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      class: {
        type: String,
        required: false,
      },
    },
    emits: ['update:visible'],
    methods: {
      close() {
        this.$emit('update:visible', false);
      }
    }
  }
</script>

<style>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 90%;
  height: 90vh;
  overflow: hidden;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 999;
}

.close-button::hover {
  background: none;
}

</style>